import { gql, useMutation } from '@apollo/client';
import { GET_DPO_TASKS, GetDpoTasksResult } from './useDpoTasksQuery';

const DELETE_DPO_TASK_FILE = gql`
  mutation DeleteDpoTaskFile($companyId: String!, $taskId: String!) {
    deleteDpoTaskFile(companyId: $companyId, taskId: $taskId)
  }
`;

export interface DeleteDpoTaskFileResult {
  deleteDpoTaskFile: boolean;
}

export interface DeleteDpoTaskFileInput {
  companyId: string;
  taskId: string;
}

export function useDpoTaskDeleteFileMutation(companyId: string) {
  return useMutation<DeleteDpoTaskFileResult, DeleteDpoTaskFileInput>(DELETE_DPO_TASK_FILE, {
    update(cache, { data }, { variables }) {
      if (!data?.deleteDpoTaskFile || !variables) return;

      // Read current tasks from cache
      const existingData = cache.readQuery<GetDpoTasksResult>({
        query: GET_DPO_TASKS,
        variables: { companyId },
      });

      if (existingData?.getDpoTasks) {
        // Update the hasFile field for the specific task
        const updatedTasks = existingData.getDpoTasks.map((task) =>
          task.id === variables.taskId ? { ...task, hasFile: false } : task
        );

        // Write back to cache
        cache.writeQuery<GetDpoTasksResult>({
          query: GET_DPO_TASKS,
          variables: { companyId },
          data: { getDpoTasks: updatedTasks },
        });
      }
    },
  });
}
